module.exports = __webpack_public_path__ + "static/media/PublicIcon.10f7eeb6.svg";